export default __webpack_public_path__ + "static/yep_img-369a02ca4ee8bee4eb30c25c4dcd9f7a.png";